import { useState } from "react";
import styled from "@emotion/styled";
import { GrButton } from "@jnpmedi/grebob";
import { UseMutateFunction } from "@tanstack/react-query";
import { useInterval } from "@newHooks/common/useInterval";
import { useSessionContext } from "@newHooks/context/session/session.context";
import { RestError } from "@maven-rest/common/HttpRequest";
import {
  AwakeAuthTokenRequest,
  AwakeAuthTokenResponse,
  RefreshAuthTokenRequest,
  RefreshAuthTokenResponse,
} from "@maven-rest/sso/AuthToken.dto";
import { secondsToReadableString } from "@maven-helper/functions/Misc.function";
import dayjs from "dayjs";

export type TimerProps = {
  awakeRequest: UseMutateFunction<AwakeAuthTokenResponse, RestError, AwakeAuthTokenRequest, unknown>;
  refreshRequest: UseMutateFunction<RefreshAuthTokenResponse, RestError, RefreshAuthTokenRequest, unknown>;
  busy: boolean;
  disabled: boolean;
  onTick: (secs: number) => void;
  defaultTitle?: string;
};

export function Timer({ awakeRequest, onTick, refreshRequest, disabled }: TimerProps) {
  const { session } = useSessionContext();

  const remainSeconds = () => dayjs(String(session?.expiryAt || 0)).diff(dayjs(), "second");

  const [remainTime, setRemainTime] = useState(secondsToReadableString(remainSeconds()));

  useInterval(() => {
    const rs = remainSeconds();

    setRemainTime(secondsToReadableString(rs));

    if (rs <= 0) {
      awakeRequest({});
    }

    onTick(rs);
  }, 1000);

  return (
    <>
      {remainTime && (
        <StyledGrButton
          variant="text"
          color="white"
          startIcon="time"
          onClick={() => {
            if (disabled) return;
            refreshRequest({});
          }}
        >
          {remainTime}
        </StyledGrButton>
      )}
    </>
  );
}

const StyledGrButton = styled(GrButton)(() => {
  return {
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:active": {
      backgroundColor: "transparent",
    },
  };
});
